import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";

const IG_URL = "https://www.instagram.com/_dutattoo";

export const InstagramCTA = () => (
  <section className="relative py-20 sm:py-28 overflow-hidden border-y border-[#27272a]/60 bg-[#0d0d10]" data-testid="instagram-section">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(224,49,49,0.07),transparent_65%)]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
      <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
        <p className="font-mono-dt text-xs uppercase tracking-[0.35em] text-[#e03131] mb-4 flex items-center gap-2">
          <Instagram size={14} /> Bastidores & Flash Days
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl" data-testid="instagram-title">
          Mais tinta no <span className="text-outline">Instagram</span>
        </h2>
        <p className="mt-5 max-w-lg text-sm sm:text-base text-zinc-400 leading-relaxed">
          Trabalhos recém-saídos da agulha, agenda aberta, flash days e bastidores do estúdio.
          Siga <span className="text-[#e2d9cc]">@_dutattoo</span> e acompanhe de perto.
        </p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.15, ease: [0.16, 1, 0.3, 1] }} className="shrink-0">
        <a href={IG_URL} target="_blank" rel="noreferrer" data-testid="instagram-follow-button"
          className="group inline-flex items-center gap-3 px-8 py-5 bg-[#e03131] text-white font-mono-dt text-xs uppercase tracking-[0.2em] rounded-md hover:bg-[#c92a2a] transition-colors duration-300">
          <Instagram size={17} />
          Seguir @_dutattoo
          <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
        <p className="mt-4 font-mono-dt text-[10px] uppercase tracking-[0.25em] text-zinc-600 text-center">
          Novos trabalhos toda semana
        </p>
      </motion.div>
    </div>
  </section>
);
